import React, { useState, useEffect, useMemo } from 'react';
import { useController, useForm } from 'react-hook-form';
import { DatePicker } from 'react-native-woodpicker'
import tw from '../../styles/tailwind';

type DateSelectorProps = {
  control: any,//?
  name: string,
  mode?: "date" | "time",
  rules?: object,
  style?: object,
}

import dayjs from 'dayjs'
import 'dayjs/locale/es'
dayjs.locale('es')


export default function DateSelector({ 
  control, name, mode = "date", rules = {}, style = {}, dateFormat = 'ddd D MMM YYYY',
  ...props 
} : DateSelectorProps) {
  const { field, fieldState: { invalid, isTouched, isDirty, error } } = useController({
    control,
    defaultValue: '',
    name,
    rules,
  })

  
  // Tue Feb 13 2014
  return (
    <DatePicker
      value={field.value}
      onDateChange={field.onChange}
      title=""
      text={
        mode == "date" ? 
          field.value ? dayjs(field.value).format(dateFormat) : ""
        : 
          field.value?.toTimeString?.()?.substr(0, 5)
      }
      style={tw.style(`bg-gray-100 px-6 h-12 rounded-lg mb-4`, invalid && `border border-red`, style)}
      isNullable={false}
      locale="es"
      // text={entry_time?.toTimeString()?.substr(0, 5)}
      androidMode={mode === 'time' ? 'time' : undefined}
      iosMode={mode === 'time' ? 'time' : undefined}
      androidDisplay={mode === 'date' ? 'calendar' : undefined}
      textColor={"#000"}
      {...props}
    />
  )
}